import React from 'react'
import { observer } from 'mobx-react'
import Tip from '../misc/Tip'

function FormHeader ({htag = 'h2', strings}) {
  const Htag = htag
  const label = typeof strings.title === 'string' && strings.title.length > 0 ?
    <Htag>{strings.title}</Htag> : null
  const description = typeof strings.description === 'string' && strings.description.length > 0 ? <div
    className={'description'} dangerouslySetInnerHTML={{ __html: strings.description }}></div> : null

  const isValidToolTip = function (obj) {
    if (typeof obj !== 'object') return false
    if (!obj.hasOwnProperty('type')) return false
    if (typeof obj.type !== 'string') return false
    if (obj.type === 'none') return
    return true
  }

  const tip = isValidToolTip(strings.tooltip) ? <Tip settings={strings.tooltip}/> : null
  const className = isValidToolTip(strings.tooltip) ? 'input-header input-header--tooltip' : 'input-header'

  return (
    <div className={className}>
      <div className={'input-header__title'}>
        {label}
        {tip}
      </div>
      {description}
    </div>
  )
}

export default observer(FormHeader)